import { getUserConfiguration, isConsumer } from 'owa-session-store';
import { optionTitle_accounts, optionSearch_accounts } from './AccountsOption.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { isFeatureEnabled } from 'owa-feature-flags';
import { Feature } from 'owa-opx';
import { isFeatureDisabledForOpx } from 'owa-calendar-opx-utils';

var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
const AccountsOption: LazyOption = createLazyOption(
    {
        key: 'multiAccounts',
        titleStringKey: optionTitle_accounts,
        searchTermsStringKey: optionSearch_accounts,
        hideTitleInFullOptions: true,
        isHidden: () => {
            const userConfiguration = getUserConfiguration();
            return (
                !isFeatureEnabled('cal-surface-refresh-addCalendar') ||
                !isFeatureEnabled('cal-multiAccounts') ||
                (isFeatureEnabled('cal-multiAccounts') &&
                    isFeatureDisabledForOpx(Feature.MultiAccounts)) ||
                isConsumer() ||
                userConfiguration?.SessionSettings?.IsExplicitLogon ||
                !userConfiguration?.PolicySettings?.PersonalAccountCalendarsEnabled
            );
        },
    },
    lazyFullModule,
    m => m.default
);
export default AccountsOption;
